module.exports = __webpack_public_path__ + "media/img/ms-linh-896dbef8.png";